import React, { useState,useEffect } from "react";
import "./Home.css";
import { FaPhoneAlt, FaCheckCircle } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import placeflight from "../assets/placeflight.jpg"
import fligtcabin from "../assets/airplane-seats.jpg"
import escapeseat from "../assets/escapeseat.jpg";
import business from "../assets/business.avif"
import dateflight from "../assets/dateflight.jpg"
import bookingtrip from "../assets/bookingtrip.png"

const Home = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
  const timer = setTimeout(() => {
    setShowPopup(true);
  }, 3000);

  return () => clearTimeout(timer);
}, []);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    const yOffset = -80; // adjust based on header height
    const y =
      section.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <div className="home-container">
      {/* ================= HEADER ================= */}
      <header className="header">
        <div className="logo">
          <img src={bookingtrip} alt="logo" />
        </div>
        <nav className="nav">
          <span onClick={() => scrollToSection("home")}>Home</span>
          <span onClick={() => scrollToSection("services")}>Services</span>
          <span onClick={() => scrollToSection("why")}>Why Us</span>
          <span onClick={() => scrollToSection("how")}>How it works</span>
        </nav>
        <div className="header-btn" onClick={() => setShowPopup(true)}>
          <FaPhoneAlt />
          <span >+1-877-560-9736</span>
        </div>
      </header>

      {/* ================= HERO ================= */}
      <section className="hero">
        <img
          src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e"
          alt="hero"
        />
        <div className="hero-text">
          <h1>Book Your Services Easily</h1>
          <p>Fast, Reliable & Affordable Solutions</p>
        </div>
      </section>

      {/* ================= SERVICES ================= */}
      <section id="services" className="services-section">
        <h2 className="services-title">Our Services</h2>

        <div className="service-row">
          {/* LEFT CONTENT */}
          <div className="service-content">
            <h3>Flight Ticket Name Change Service</h3>

            <p className="price">Starting from $27.99</p>

            <p className="desc">
              Did you make a mistake when you booked your flight? Our Flight
              Ticket Name Change Service is available to assist, so don't worry.
              We make the process easy and stress-free, whether it's a minor
              spelling mistake, a missing middle name, or a full name adjustment
              for legal reasons. Passenger names are subject to stringent
              airline regulations, and even a small discrepancy may result in
              problems during check-in. In order to prevent last-minute flight
              delays, our knowledgeable staff complies with airline regulations
              to guarantee that your name is accurately changed on your ticket.
              Allow us to handle the documentation and correspondence with the
              airline so you can travel with assurance that your information is
              correct and safe.
            </p>

          

            <button className="enquire-btn" onClick={() => setShowPopup(true)}>
              Enquire Now
            </button>
          </div>

          {/* RIGHT IMAGE */}
          <div className="service-image">
            <img
              src={placeflight}
              alt="service"
            />
          </div>
        </div>
      </section>
      {/* ================= SERVICES 2================= */}
      <section className="services-section">
        <div className="service-row">
          {/* RIGHT IMAGE */}
          <div className="service-image">
            <img
              src={fligtcabin}
              alt="service"
            />
          </div>
          {/* LEFT CONTENT */}
          <div className="service-content">
            <h3>Flight Cabin Upgrade Service</h3>

            <p className="price">Starting from $27.99</p>

            <p className="desc">
              Do you want to travel in a more comfortable or preferred seat?
              After making a reservation, changing your seating arrangement is
              simple with our Flight Seat Update Service. We manage the
              procedure fast and effectively, whether you want to upgrade to
              more legroom, change to a window seat, or sit alongside your
              traveling companions. Although seat modifications are frequently
              permitted by airlines, understanding their rules and costs might
              be challenging. Our staff makes sure your seat is changed in
              accordance with your preferences while adhering to the airline's
              policies and availability. Get the seat that works best for you to
              have a better travel experience. So that you can unwind and enjoy
              your flight, let us handle the details.
            </p>


            <button className="enquire-btn" onClick={() => setShowPopup(true)}>
              Enquire Now
            </button>
          </div>
        </div>
      </section>

      {/* ================= SERVICES 3================= */}
      <section className="services-section">
        <div className="service-row">
          {/* LEFT CONTENT */}
          <div className="service-content">
            <h3>Flight Seat Update Service</h3>

            <p className="price">Starting from $27.99</p>

            <p className="desc">
              Do you have a preferable or more comfy seat for your trip? After
              making a reservation, changing your seat arrangement is simple
              with our Flight Seat Update Service. We take care of the process
              fast and effectively, whether you want to upgrade to more legroom,
              relocate to a window seat, or sit alongside your traveling
              buddies. Although airlines frequently permit seat adjustments, it
              might be challenging to understand their rules and costs. Our
              staff makes sure your seat is changed in accordance with your
              choices while adhering to airline policies and availability.
              Choose the seat that works best for you to have a better travel
              experience. Let us take care of the details so you can enjoy your
              flight and unwind.
            </p>

           

            <button className="enquire-btn" onClick={() => setShowPopup(true)}>
              Enquire Now
         </button>
          </div>

          {/* RIGHT IMAGE */}
          <div className="service-image">
            <img
              src={escapeseat}
              alt="service"
            />
          </div>
        </div>
      </section>
      <section className="services-section">
        <div className="service-row">
          {/* RIGHT IMAGE */}
          <div className="service-image">
            <img
              src={business}
              alt="service"
            />
          </div>

          {/* LEFT CONTENT */}
          <div className="service-content">
            <h3>Business Class seat Upgrade</h3>

            <p className="price">Starting from $27.99</p>

            <p className="desc">
              Upgrade your journey with our Business Class Seat Upgrade in
              Flight, designed to bring you premium comfort and a superior
              flying experience. Whether you want extra legroom, priority
              services, gourmet meals, or a more peaceful cabin environment, we
              make upgrading from economy to business class simple and
              hassle-free. Airline upgrade rules, availability, and pricing can
              often be confusing, but our team takes care of everything—checking
              options, handling the process, and securing the best possible
              upgrade for you. Enjoy a smoother, more relaxing trip with added
              luxury while we manage all the details for you.
            </p>

            <button className="enquire-btn" onClick={() => setShowPopup(true)}>
              Enquire Now
            </button>
          </div>
        </div>
      </section>
      <section className="services-section">
        <div className="service-row">
          {/* RIGHT IMAGE */}

          {/* LEFT CONTENT */}
          <div className="service-content">
            <h3>Date Change on Flight Ticket</h3>

            <p className="price">Starting from $27.99</p>

            <p className="desc">
              Need to change your travel plans? Our Flight Ticket Date Change
              Service makes it easy to reschedule your journey without the usual
              stress. Whether your plans have shifted unexpectedly or you simply
              need more flexibility, we handle the entire date change process
              for you. Airline policies, fare differences, and change fees can
              be confusing, but our team takes care of everything—checking
              availability, managing the modifications, and ensuring your ticket
              is updated smoothly. Enjoy peace of mind knowing your travel plans
              are adjusted according to your needs while we handle all the
              details for you.
            </p>

         
            <button className="enquire-btn" onClick={() => setShowPopup(true)}>
              Enquire Now
            </button>
          </div>
          <div className="service-image">
            <img
              src={dateflight}
              alt="service"
            />
          </div>
        </div>
      </section>

      {/* ================= WHY US ================= */}
      <section id="why" className="why-us-section">
        <div className="container">
          <h2 className="section-title">Why Choose Us</h2>

          <div className="why-card-grid">
            <div className="why-card">
              <div className="icon">
                <FaCheckCircle />
              </div>
              <h3>Best Prices</h3>
              <p>We offer competitive pricing with no hidden charges.</p>
            </div>

            <div className="why-card">
              <div className="icon">
                <FaCheckCircle />
              </div>
              <h3>24/7 Support</h3>
              <p>Our team is always available to assist you anytime.</p>
            </div>

            <div className="why-card">
              <div className="icon">
                <FaCheckCircle />
              </div>
              <h3>Trusted Service</h3>
              <p>Thousands of happy customers trust our platform.</p>
            </div>

            <div className="why-card">
              <div className="icon">
                <FaCheckCircle />
              </div>
              <h3>Fast Booking</h3>
              <p>Quick and seamless booking experience every time.</p>
            </div>
          </div>
        </div>
      </section>
      {/* ================= HOW IT WORKS ================= */}
      <section id="how" className="how-section">
        <div className="container">
          <h2 className="section-title light">How It Works</h2>

          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">01</div>
              <h3>Select Service</h3>
              <p>
                Browse through our wide range of services and select the one
                that best suits your requirements. Each service is clearly
                explained so you can make an informed decision without any
                confusion.
              </p>
            </div>

            <div className="step-card">
              <div className="step-number">02</div>
              <h3>Fill Details</h3>
              <p>
                Enter all the necessary information in our easy-to-use form.
                We’ve designed the process to be quick and hassle-free, ensuring
                your details are captured accurately and securely.
              </p>
            </div>

            <div className="step-card">
              <div className="step-number">03</div>
              <h3>Make Payment</h3>
              <p>
                Complete your payment using our secure and trusted payment
                gateway. Multiple payment options are available, giving you
                flexibility and ensuring a smooth transaction experience.
              </p>
            </div>

            <div className="step-card">
              <div className="step-number">04</div>
              <h3>Get Confirmation</h3>
              <p>
                Once your booking is successful, you’ll receive an instant
                confirmation along with all the necessary details. Our team will
                keep you updated at every step until your service is completed.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer className="footer">
        <div className="container footer-container">
          {/* Column 1 */}
          <div className="footer-col">
            <h3 className="footer-logo">BookingTrip</h3>
            <p>
              We provide reliable and fast services with complete transparency.
              Our goal is to make your experience smooth and hassle-free.
            </p>
          </div>

          {/* Column 2 */}
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
             <li><span onClick={() => scrollToSection("home")}>Home</span></li>
<li><span onClick={() => scrollToSection("services")}>Services</span></li>
<li><span onClick={() => scrollToSection("why")}>Why Choose Us</span></li>
<li><span onClick={() => scrollToSection("how")}>How It Works</span></li>
            </ul>
          </div>

         {/* Column 3 */}
<div className="footer-col">
  <h4>Services</h4>
  <ul>
    <li>
      <span onClick={() => scrollToSection("services")}>
        Flight Booking
      </span>
    </li>
    <li>
      <span onClick={() => scrollToSection("services")}>
        Hotel Booking
      </span>
    </li>
    <li>
      <span onClick={() => scrollToSection("services")}>
        Tour Packages
      </span>
    </li>
    <li>
      <span onClick={() => scrollToSection("services")}>
        Visa Services
      </span>
    </li>
  </ul>
</div>

          {/* Column 4 */}
          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li>Phone +1-877-560-9736</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()}BookingTrip. All rights reserved.</p>
        </div>
      </footer>
      {/* ================= POPUP ================= */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            {/* LEFT IMAGE */}
            <div className="popup-left">
              <img
                src="https://images.unsplash.com/photo-1521791136064-7986c2920216"
                alt="support"
              />
            </div>

            {/* RIGHT CONTENT */}
            <div className="popup-right">
              <button className="close-btn" onClick={() => setShowPopup(false)}>
                <IoClose />
              </button>

              <h2>Ready to Talk?</h2>
              <p>
                Our specialists are available to answer your questions and help
                you get started. Give us a call!
              </p>

              <button className="call-btn">
               +1-877-560-9736
                <FaPhoneAlt />

                Call Now
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
